import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, formatApiError } from "@/lib/api";

export const PlanEditDialog = ({ p, onClose, onSaved }) => {
  const [f, setF] = useState({ price: (p.price_cents / 100).toFixed(2), description: p.description || "", mp_link: p.mp_link || "", active: p.active });
  const save = async () => {
    const cents = Math.round(parseFloat(String(f.price).replace(",", ".")) * 100);
    if (!cents || cents <= 0) return toast.error("Preço inválido");
    if ((cents !== p.price_cents || f.mp_link !== p.mp_link) && !window.confirm("Você está alterando preço ou link. Confirma que tem autorização para isso? O link precisará ser verificado de novo.")) return;
    try { await api.put(`/plans/${p.id}`, { price_cents: cents, description: f.description, mp_link: f.mp_link.trim(), active: f.active }); toast.success(`${p.id} salvo`); onSaved(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="bg-[#111827] border-[#1F2937] text-[#F9FAFB] max-w-lg" data-testid="plan-edit-dialog">
        <DialogHeader>
          <DialogTitle>Editar plano {p.id}</DialogTitle>
          <DialogDescription className="text-[#9CA3AF]">{p.label}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <label className="block text-xs text-[#9CA3AF] space-y-1"><span>Preço (R$)</span><Input value={f.price} onChange={(e) => setF({ ...f, price: e.target.value })} className="input-dark font-mono" data-testid="plan-edit-price" /></label>
          <label className="block text-xs text-[#9CA3AF] space-y-1"><span>Descrição (a IA pode citar)</span><Input value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} className="input-dark" data-testid="plan-edit-description" /></label>
          <label className="block text-xs text-[#9CA3AF] space-y-1"><span>Link fixo do Mercado Pago</span><Input value={f.mp_link} onChange={(e) => setF({ ...f, mp_link: e.target.value })} className="input-dark font-mono" data-testid="plan-edit-link" /></label>
          <div className="flex items-center justify-between mode-option"><span className="text-sm">Disponível para venda</span><Switch checked={f.active} onCheckedChange={(v) => setF({ ...f, active: v })} data-testid="plan-edit-active" /></div>
        </div>
        <DialogFooter><Button className="btn-primary" onClick={save} data-testid="plan-edit-save">Salvar</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
